module.exports = "/images/vendor/flag-icon-css/flags/1x1/nu.svg?1db5a99d1f547d957911461879d5785e";